import { caseApi } from 'modules/cm/api';
import { CaseId } from 'modules/cm/api/cases/types';
import { Dispatch } from 'redux';
import { removeProperty } from '../../store/actions';
import { PropertyId } from 'modules/cm/api/cases/repaymentStrategy/property/Property';

const removePropertyUseCase = (caseId: CaseId, propertyId: PropertyId) => {
  const api = caseApi(caseId).repaymentStrategyApi.property;
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      await api.remove(propertyId);

      dispatch(removeProperty(propertyId));
    } catch (error) {}
  };
};

export default removePropertyUseCase;
